export const getBrowserDeviceInfo = () => {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  let browser = ''
  let device = ''
  let OS = ''

  // Browser detection
  if (/chrome|crios|crmo/i.test(userAgent)) {
    browser = 'Chrome'
  } else if (/firefox|fxios/i.test(userAgent)) {
    browser = 'Firefox'
  } else if (/safari/i.test(userAgent)) {
    browser = 'Safari'
  } else if (/msie|trident/i.test(userAgent)) {
    browser = 'Internet Explorer'
  } else if (/edge/i.test(userAgent)) {
    browser = 'Edge'
  } else if (/opera|opr/i.test(userAgent)) {
    browser = 'Opera'
  } else {
    browser = 'Unknown'
  }

  // Device detection
  if (/android/i.test(userAgent)) {
    device = 'Android'
  } else if (/iphone|ipod/i.test(userAgent)) {
    device = 'iPhone/iPod'
  } else if (/ipad/i.test(userAgent)) {
    device = 'iPad'
  } else if (/windows phone/i.test(userAgent)) {
    device = 'Windows Phone'
  } else if (/macintosh|mac os/i.test(userAgent)) {
    device = 'Mac'
  } else if (/windows/i.test(userAgent)) {
    device = 'Windows'
  } else if (/linux/i.test(userAgent)) {
    device = 'Linux'
  } else {
    device = 'Unknown Device'
  }

  // Operating system detection
  if (/android/i.test(userAgent)) {
    OS = 'Android OS'
  } else if (/iphone|ipod|ipad/i.test(userAgent)) {
    OS = 'iOS'
  } else if (/windows/i.test(userAgent)) {
    OS = 'Windows'
  } else if (/mac os/i.test(userAgent)) {
    OS = 'Mac OS'
  } else if (/linux/i.test(userAgent)) {
    OS = 'Linux'
  } else {
    OS = 'Unknown OS'
  }

  return { browser, device, OS }
}
